// extracted by mini-css-extract-plugin
export default {"icon":"bound_state_icon__x0HYb","unbound":"bound_state_unbound__kvWQT bound_state_icon__x0HYb","bound":"bound_state_bound__s14vZ bound_state_icon__x0HYb"};